const Actions = {
  // action types
  VERIFY_AUTH : "verifyAuth",
  LOGIN : "login",
  LOGOUT : "logout",
  REGISTER : "register",
  UPDATE_USER : "updateUser",
  FORGOT_PASSWORD : "forgotPassword",
};

const Mutations = {
  // mutation types
  PURGE_AUTH : "logOut",
  SET_AUTH : "setAuth",
  SET_USER : "setUser",
  SET_AVATAR_NUMBER : "setAvatarNumber",
  SET_PASSWORD : "setPassword",
  SET_ERROR : "setError",
  SET_BREADCRUMB : "setBreadcrumb",
  SET_BREADCRUMB_SHOW : "setBreadcrumbShow",
  SET_CURRENT_PATH : "setCurrentPath",
  SET_ACCOUNT_RESOURCE : "setAccountResource",
  SET_ACCOUNT_WARNING : "setAccountWarning",
  SET_ACCOUNT_MENU : "setAccountMenu",
  SET_ACCOUNT_MENU_ACTIVE_INDEX: "setAccountMenuActiveIndex",
  SET_CORP_INFO : "setCorpInfo",
  SET_ACCOUNT_ENGINE: "setAccountEngine"
};

export { Actions, Mutations };
